import { getPath } from '@/router/common'

const baseUrl = {
  title: '快递出入仓',
  path: 'Courier'
}
// /Courier/warehousingManagement
// /Courier/warehousingDetails
// /Courier/Expresspackage
// /Courier/addWarehousingManagement
// /Courier/addWarehousingManagement_SMALL
// /Courier/addWarehousingManagement_76972
// /Courier/Get_CourierDetails

export default [
  {
    path: getPath('warehousingDetails', baseUrl),
    name: 'WarehousingDetails',
    component: () => import(/* webpackChunkName: "warehousingDetails" */ '@/views/courier/warehousingDetails/index.vue'),
    meta: {
      title: '出入仓明细'
    }
  },
  {
    path: getPath('warehousingManagement', baseUrl),
    name: 'WarehousingManagement',
    component: () => import(/* webpackChunkName: "warehousingManagement" */ '@/views/courier/warehousingManagement/index.vue'),
    meta: {
      title: '出入仓管理'
    }
  },
  {
    path: getPath('Expresspackage', baseUrl),
    name: 'ExpresspackageCourier',
    component: () => import(/* webpackChunkName: "Expresspackage" */ '@/views/courier/expresspackage/index.vue'),
    meta: {
      title: '快递集包功能'
    }
  },
  {
    path: getPath('addWarehousingManagement', baseUrl),
    name: 'AddWarehousingManagement',
    component: () => import(/* webpackChunkName: "AddWarehousingManagement" */ '@/views/courier/addWarehousingManagement/index.vue'),
    meta: {
      title: '订单录入'
    }
  },
  {
    path: getPath('addWarehousingManagement_SMALL', baseUrl),
    name: 'AddWarehousingManagement_SMALL',
    component: () => import(/* webpackChunkName: "Get_CourierDetails" */ '@/views/courier/addWarehousingManagement_SMALL/index.vue'),
    meta: {
      title: '新增单价SMALL'
    }
  },
  {
    path: getPath('addWarehousingManagement_76972', baseUrl),
    name: 'AddWarehousingManagement_76972',
    component: () => import(/* webpackChunkName: "Get_CourierDetails" */ '@/views/courier/addWarehousingManagement_76972/index.vue'),
    meta: {
      title: '新增单价76972'
    }
  },
  //
  {
    path: getPath('Get_CourierDetails', baseUrl),
    name: 'GetCourierDetails',
    component: () => import(/* webpackChunkName: "Get_CourierDetails" */ '@/views/courier/getCourierDetails/index.vue'),
    meta: {
      title: '快递单明细'
    }
  },
  {
    path: getPath('AddPackageDetails', baseUrl),
    name: 'AddPackageDetails',
    component: () => import(/* webpackChunkName: "AddPackageDetails" */ '@/views/courier/addPackageDetails/index.vue'),
    meta: {
      title: '出入仓明细-新增-修改'
    }
  },
  {
    path: getPath('createTYD', baseUrl),
    name: 'createTYD',
    component: () => import(/* webpackChunkName: "createTYD" */ '@/views/courier/createTYD/index.vue'),
    meta: {
      title: '拆票生成托运单'
    }
  },
  {
    path: getPath('Ex_kd', baseUrl),
    name: 'Courier_Ex_kd',
    component: () => import(/* webpackChunkName: "Courier_Ex_kd" */ '@/views/courier/ex_kd/index.vue'),
    meta: {
      title: '集包明细'
    }
  },
  {
    path: getPath('Get_CourierDetails', baseUrl),
    name: 'Get_CourierDetails',
    component: () => import(/* webpackChunkName: "Get_CourierDetails" */ '@/views/courier/get_CourierDetails/index.vue'),
    meta: {
      title: '快递单明细'
    }
  }
]
